import {useEventGiftingClassifiedCategory} from '~/CreateFabricInvitation/routes/EventGifting/useEventGiftingClassifiedCategory';
import {CrowdfundOption} from './components/Crowdfund/CrowdfundOption';
import {DonationOption} from './components/Donation/DonationOption';
import {Section} from './components/Section/Section';

export const OtherGiftOptions = () => {
  const {isFuneralEvent} = useEventGiftingClassifiedCategory();

  return (
    <Section title={isFuneralEvent ? '' : 'Other gifting options'}>
      <DonationOption />
      <CrowdfundOption />
    </Section>
  );
};
